'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _footer = require('./footer');

var _footer2 = _interopRequireDefault(_footer);

var _footer_text = require('./footer_text');

var _footer_text2 = _interopRequireDefault(_footer_text);

var _footer_links = require('./footer_links');

var _footer_links2 = _interopRequireDefault(_footer_links);

var _footer_link = require('./footer_link');

var _footer_link2 = _interopRequireDefault(_footer_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    Footer: _footer2.default,
    FooterText: _footer_text2.default,
    FooterLinks: _footer_links2.default,
    FooterLink: _footer_link2.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/footer/index.js
// module id = 515
// module chunks = 7